import Event from '../../core/Event';

export default class OrderSafeDraftFailed extends Event {
    public static type = 'OrderSafeDraftFailed';

    constructor() {
        super(OrderSafeDraftFailed.type);
    }
}



// WEBPACK FOOTER //
// ./src/application/order/events/OrderSafeDraftFailed.ts